import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/12_green_field/12_green_field"
 * Contains 1 texture(s)
 */
export class Desktop12GreenFieldAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/12_green_field/12_green_field';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '12_green_field.jpg'
    ] as const;
}
